import React from 'react';
import "../App.css";
import { TASK_STATUSES } from '../core/constants';

// ─── BADGE COMPONENT ──────────────────────────────────────────────────
export function Badge({ status, label, style }) {
  const s = TASK_STATUSES.find(x => x.id === status);
  const bg = s?.bg || "#F9FAFB";
  const color = s?.color || "#6B7280";
  return (
    <span className="badge" style={{ background: bg, color, ...style }}>
      <span className="badge-dot" style={{ background: color }} />
      {label || s?.label || status}
    </span>
  );
}
